export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE = 1;
